const objectiveBaseUrl = '/objectives';

export default {
    /**
     *
     * @returns {Promise<unknown>}
     */
    async getCompute(categoryCode, currency, period, item_id, item_category_id, assignee) {
        let objectiveType = '';
        switch (categoryCode) {
            case 'forecast_turnover':
                objectiveType = 'forecast-turnover';
                break;
            case 'turnover':
            default:
                objectiveType = 'turnover';
                break;
        }

        return await ApiClient.post(
            `${objectiveBaseUrl}/${objectiveType}/compute`,
            {},
            { currency, period, item_id, item_category_id, assignee },
        );
    },

    /**
     *
     * @returns {Promise<unknown>}
     */
    async getComputeForecastTurnover(currency, period, item_id, item_category_id, assignee) {
        return await ApiClient.post(
            `${objectiveBaseUrl}/forecast-turnover/compute`,
            {},
            { currency, period, item_id, item_category_id, assignee },
        );
    },

    /**
     * Call to the API to create a new Objective
     *
     * @param {Object} formData
     * @returns {promise}
     */
    createObjective(formData) {
        return new Promise((resolve, reject) => {
            ApiClient.post(objectiveBaseUrl, {}, formData)
                .then((response) => resolve(response.data))
                .catch((errors) => reject(errors.message));
        });
    },

    /**
     * @returns {Promise}
     */
    async getMetaDatas() {
        return ApiClient.get(`${objectiveBaseUrl}/metadata`);
    },

    /**
     * @param {Object} queryData
     * @returns {Promise}
     */
    getObjectives(queryData) {
        delete queryData.total;
        delete queryData.count;
        return ApiClient.get(objectiveBaseUrl, queryData);
    },

    /**
     * @param {Number} objectiveId
     * @returns {Promsie}
     */
    deleteObjective(objectiveId) {
        return ApiClient.del(`${objectiveBaseUrl}/${objectiveId}`);
    },

    /**
     * @param {Object} queryParams
     * @param {Object} dataParams
     * @returns {Promise}
     */
    searchObjectives(queryParams, dataParams) {
        delete queryParams.total;
        delete queryParams.count;
        return ApiClient.post(`${objectiveBaseUrl}/search`, queryParams, dataParams);
    },

    /**
     * @param {Number} objectiveId
     * @param {Object} formData
     * @returns {Promise}
     */
    updateObjective(objectiveId, formData) {
        return ApiClient.put(`${objectiveBaseUrl}/${objectiveId}`, {}, formData);
    },

    /**
     * @returns {Promise}
     */
    getMetadatasUpsell() {
        return ApiClient.get(`${objectiveBaseUrl}/metadata/upsell`);
    },
};
